export default {"src":"/_next/static/media/unity.4e0bcc82.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};